"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseActionResponseStatus = void 0;
var PurchaseActionResponseStatus;
(function (PurchaseActionResponseStatus) {
    PurchaseActionResponseStatus["SUCCESS"] = "SUCCESS";
    PurchaseActionResponseStatus["FAILURE"] = "FAILURE";
})(PurchaseActionResponseStatus = exports.PurchaseActionResponseStatus || (exports.PurchaseActionResponseStatus = {}));
